<header [ngClass]="styles.headerContainer" class="theme-accent-border position-relative">
	<div class="util-absolute-fill" layout="column" layout-wrap="false" flex-justify="center" [ngClass]="styles.headerAbsoluteContainer">

		<div [ngClass]="styles.header" [tooltip]="headerTooltip || header" [placement]="'top left'" [containerClass]="styles.tooltipContainer" [innerHTML]="'<' + headerTag + '>' + escape(header) + '</' + headerTag + '>'"></div>

		<span *ngIf="subheader" [ngClass]="styles.subheader" [tooltip]="subheader" [placement]="'top left'" [containerClass]="styles.tooltipContainer">
			{{ subheader }}
		</span>

	</div>
</header>

<section flex="fill" flex-align="center" flex-justify="center" layout="column" layout-wrap="false" [ngClass]="[styles.content, noContentPadding ? 'padding-0' : '']">
	<ng-content></ng-content>
</section>

<footer *ngIf="footers?.length" flex="fill" layout="row" [ngClass]="styles.footer">
	<div flex="fill" *ngFor="let footer of footers" [ngClass]="styles.footerItem">
		<div>
			{{ footer.title }}
		</div>
		<div class="padding-top-10">
			{{ footer.data }}
		</div>
	</div>
</footer>
